import { SkeletonBlock, SkeletonText } from '@/components/common/skeleton';

import styles from './warranty-claim-detail-skeleton.module.scss';

/**
 * Loading placeholder for `WarrantyClaimDetailDrawer`'s body. Mirrors the real detail
 * layout — header (ref + status chip + device name), a couple of labelled fields, a few
 * status-timeline rows, comment rows, and the response composer area — so the swap to real
 * content doesn't jump. Used internally by the drawer (no barrel export).
 */
export function WarrantyClaimDetailSkeleton() {
  return (
    <div className={styles.body} aria-busy="true" aria-label="Loading claim">
      {/* Header: ref + status chip, then device name. */}
      <div className={styles.head}>
        <div className={styles.refRow}>
          <SkeletonBlock width={72} height={14} />
          <SkeletonBlock width={88} height={22} radius={24} />
        </div>
        <SkeletonBlock width="65%" height={24} />
      </div>

      {/* Labelled fields (Order ID / Reason / Description). */}
      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className={styles.field}>
          <SkeletonBlock width={96} height={13} />
          <SkeletonBlock width={i === 2 ? '90%' : '55%'} height={14} />
        </div>
      ))}

      {/* Status timeline rows: icon disc + title/date. */}
      <div className={styles.timeline}>
        {Array.from({ length: 3 }, (_, i) => (
          <div key={i} className={styles.timelineItem}>
            <SkeletonBlock width={28} height={28} circle />
            <div className={styles.timelineText}>
              <SkeletonBlock width={140} height={14} />
              <SkeletonBlock width={84} height={12} />
            </div>
          </div>
        ))}
      </div>

      {/* Comment thread rows. */}
      <div className={styles.thread}>
        {Array.from({ length: 2 }, (_, i) => (
          <div key={i} className={styles.comment}>
            <SkeletonBlock width="40%" height={13} />
            <SkeletonText lines={2} lineHeight={12} lastLineWidth="70%" />
          </div>
        ))}
      </div>

      {/* Response composer area. */}
      <div className={styles.composer}>
        <SkeletonBlock width={160} height={13} />
        <SkeletonBlock width="100%" height={76} radius={10} />
        <SkeletonBlock width={148} height={40} radius={10} />
      </div>
    </div>
  );
}
